import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface BillingState {
  currentPlan: any,
  subscription: any, 
  paymentMethod: any, 
  group: any, 
  customer: any, 
  isRefreshSubscription: boolean, 
  activeCount: number; 
  nextInvoicePreview: any; 
  invoices: any[]; 
}

// ---------------

const initialState: BillingState = {
  currentPlan: null, 
  subscription: null, 
  paymentMethod: null, 
  customer: null, 
  group: null, 
  isRefreshSubscription: false, 
  activeCount: 0, 
  nextInvoicePreview: null, 
  invoices: [], 
};

// ---------------


export const billingSlice = createSlice({

  name: 'billing',

  initialState,

  reducers: {

    setCurrentPlan: (state, action: PayloadAction<any>) => { 

        state.currentPlan = action.payload; 

    },
    setSubscription: (state, action: PayloadAction<any>) => { 

        state.subscription = action.payload; 

    }, 
    setPaymentMethod: (state, action: PayloadAction<any>) => { 

        state.paymentMethod = action.payload; 

    }, 
    setCustomer: (state, action: PayloadAction<any>) => { 

        state.customer = action.payload; 

    }, 
    setGroup: (state, action: PayloadAction<any>) => { 

        state.group = action.payload; 

    }, 
    setIsRefreshSubscription: (state, action: PayloadAction<any>) => { 

        state.isRefreshSubscription = action.payload; 

    },
    setActiveCount: (state, action: PayloadAction<number>) => { 

        state.activeCount = action.payload; 

    },
    setNextInvoicePreview: (state, action: PayloadAction<number>) => { 

        state.nextInvoicePreview = action.payload; 

    },
    setInvoices: (state, action: PayloadAction<any>) => { 

        state.invoices = action.payload; 

    },  
    resetBilling: (state) => { 
        
      state.currentPlan = null; 
      state.subscription = null; 
      state.paymentMethod = null; 
      state.customer = null; 
      state.group = null; 
      state.isRefreshSubscription = false; 
      state.activeCount = 0; 
      state.nextInvoicePreview = null; 
      state.invoices = []; 

    } 

  },

}); 

// ---------------

export const { 
  setCurrentPlan, 
  setSubscription,
  setPaymentMethod, 
  setCustomer, 
  setGroup, 
  setIsRefreshSubscription, 
  setActiveCount, 
  setNextInvoicePreview,
  setInvoices, 
  resetBilling 
} = billingSlice.actions;

export default billingSlice.reducer;